export default __webpack_public_path__ + "static/media/AFM_rond_risicoscore2.5f7cc9e3.jpg";